module.exports = __webpack_public_path__ + "static/media/29COICT5.90710a30.jpg";